import * as cn from "classnames";
import * as React from "react";
import * as styles from "./styles.css";
import Container from "backpack-ui/dist/components/container";
import { Heading } from "backpack-ui/dist/components/text";
var MastheadBackground = function (_a) {
    var backgroundImage = _a.backgroundImage, backgroundHeight = _a.backgroundHeight, logoImage = _a.logoImage, logoWidth = _a.logoWidth, logoAlt = _a.logoAlt, text = _a.text;
    return (React.createElement("div", { className: cn("MastheadBackground", styles.backgroundImage), style: {
            backgroundImage: "url(" + backgroundImage + ")",
            height: "" + backgroundHeight,
        } },
        React.createElement(Container, null,
            React.createElement("img", { className: styles.img, src: logoImage, width: logoWidth, alt: logoAlt }),
            React.createElement(Heading, { className: styles.heading, level: 1, weight: "light" }, text))));
};
export default MastheadBackground;



//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/components/mastheadBackground/index.tsx
// module id = qdDr
// module chunks = 3